import script from "./videomonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./videomonitor.vue?vue&type=script&setup=true&lang=js"

import "./videomonitor.vue?vue&type=style&index=0&id=0d457aa4&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d457aa4"]])

export default __exports__